import { useCallback } from "react";
import type { SetterOrUpdater } from "recoil";
import { atomFamily, useSetRecoilState } from "recoil";

import { useFormRequest } from "../../../../actions/data";
import type { BodyData, Form } from "../../../../types/main.d";
import type { ContactsListType } from "../types";

export const confirmContactFormRequest = atomFamily<Form.Request, number>({
  key: "confirmContactFormRequest",
  default: {
    status: "DEFAULT",
  },
});

export const useConfirmContactFormSubmit = (
  userId: number,
  setContactsData: SetterOrUpdater<ContactsListType>
) => {
  const setFormRequest = useSetRecoilState(confirmContactFormRequest(userId));
  const confirmContactFormSubmit = useFormRequest({
    setFormRequest,
    url: `/users/confirmcontact/${userId}/`,
  });
  return useCallback(
    (bodyData: BodyData) =>
      confirmContactFormSubmit(bodyData).then((successData) =>
        setContactsData((currVal) => ({
          ...currVal,
          response: currVal.response.map((v) =>
            v.id === userId
              ? {
                  ...v,
                  ...successData,
                }
              : v
          ),
        }))
      ),
    [confirmContactFormSubmit, setContactsData, userId]
  );
};
